import { useState } from "react";
import { Champ } from "@/components/commun";
import { Logo } from "@/components/shell/Logo";

export const FormulaireMotDePasse = ({ titre, sousTitre, bouton, onValider, erreurExterne }) => {
  const [mdp, setMdp] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [erreur, setErreur] = useState("");
  const [envoi, setEnvoi] = useState(false);

  const soumettre = async (e) => {
    e.preventDefault();
    if (mdp !== confirmation) return setErreur("Les deux mots de passe ne correspondent pas.");
    setErreur(""); setEnvoi(true);
    try { await onValider(mdp); } catch (err) { setErreur(err.message); } finally { setEnvoi(false); }
  };

  return (
    <div className="min-h-screen flex flex-col px-5 py-8 sm:items-center sm:justify-center">
      <div className="mb-10 sm:mb-8"><Logo /></div>
      {erreurExterne ? (
        <div className="at-card p-7 max-w-md w-full" data-testid="password-page-error"><p className="font-semibold">{erreurExterne}</p></div>
      ) : (
        <form onSubmit={soumettre} className="at-card p-6 sm:p-9 max-w-md w-full space-y-5 at-rise" data-testid="password-form">
          <div>
            <h1 className="text-2xl font-bold tracking-tight">{titre}</h1>
            {sousTitre && <p className="at-muted text-sm mt-1">{sousTitre}</p>}
          </div>
          <Champ label="Mot de passe (8 caractères minimum)" id="nouveau-mdp" type="password" autoComplete="new-password" required minLength={8} value={mdp} onChange={(e) => setMdp(e.target.value)} data-testid="password-input" />
          <Champ label="Confirmer le mot de passe" id="confirm-mdp" type="password" autoComplete="new-password" required value={confirmation} onChange={(e) => setConfirmation(e.target.value)} data-testid="password-confirm-input" />
          {erreur && <p className="text-sm font-semibold" style={{ color: "var(--danger)" }} data-testid="password-error">{erreur}</p>}
          <button type="submit" disabled={envoi} className="at-btn at-btn-primary w-full" data-testid="password-submit-button">{envoi ? "Enregistrement…" : bouton}</button>
        </form>
      )}
    </div>
  );
};
